
import ApplicationController from '../application_controller.js';


export default class extends ApplicationController {
  
    initialize() {


    }

    connect () {

      }

    
  
}
